<div class="form-tabs-bar" id="tabs-bar">
  <div class="form-tab" (click)="changeTab('application-form')">
    <div [ngClass]="currentTab === 'application-form' ? 'selected-tab-text' : 'tab-text'" #applicationFormText>APPLICATION FORM</div>
    <div [ngClass]="currentTab === 'application-form' ? 'selected-form-tab' : 'hidden-form-tab'" id="applicationForm" #applicationForm>
      <svg width="146" height="14" viewBox="0 0 146 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14C2 12.3431 3.34315 11 5 11H141C142.657 11 144 12.3431 144 14H2Z" fill="#E57016" />
      </svg>
    </div>
  </div>
  <div class="form-tab" (click)="changeTab('fee-info')">
    <div [ngClass]="currentTab === 'fee-info' ? 'selected-tab-text':'tab-text'" #feeInformationText>FEE INFORMATION</div>
    <div [ngClass]="currentTab === 'fee-info' ? 'selected-form-tab' : 'hidden-form-tab'" id="feeInformation" #feeInformation>
      <svg width="146" height="14" viewBox="0 0 146 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14C2 12.3431 3.34315 11 5 11H141C142.657 11 144 12.3431 144 14H2Z" fill="#E57016" />
      </svg>
    </div>
  </div>
  <div class="form-tab" (click)="changeTab('upload-documents')">
    <div [ngClass]="currentTab === 'upload-documents' ? 'selected-tab-text':'tab-text'" #applicationChecklistText>UPLOAD DOCUMENTS</div>
    <div [ngClass]="currentTab === 'upload-documents' ? 'selected-form-tab' : 'hidden-form-tab'" id="applicationChecklist" #applicationChecklist>
      <svg width="146" height="14" viewBox="0 0 146 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14C2 12.3431 3.34315 11 5 11H141C142.657 11 144 12.3431 144 14H2Z" fill="#E57016" />
      </svg>
    </div>
  </div>
  <a href="https://www.ama-assn.org/about/united-states-adopted-names-usan/usan-council#usan-program-staff-contacts"
    target="_blank">
    <div class="form-tab">
      <div [ngClass]="currentTab === 'contact-usan' ? 'selected-tab-text':'tab-text'" #contactUsanText>CONTACT USAN</div>
      <div [ngClass]="currentTab === 'contact-usan' ? 'selected-form-tab' : 'hidden-form-tab'" id="contactUsan" #contactUsan>
        <svg width="146" height="14" viewBox="0 0 146 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 14C2 12.3431 3.34315 11 5 11H141C142.657 11 144 12.3431 144 14H2Z" fill="#E57016" />
        </svg>
      </div>
    </div>
  </a>
</div>